import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'shStringJoin', standalone: true })
export class StringJoinPipe implements PipeTransform {
  transform(value: any, separator = ', '): string {
    if (value == null) {
      return '';
    }

    if (Array.isArray(value)) {
      return value.join(separator);
    }

    return value;
  }
}
